import { FormattedMessage } from 'react-intl';
import { FormattedMessageMarkdown } from '../../i18n/FormattedMessageMarkdown';

export const topics = [
  {
    question: <FormattedMessage id="faq.question_1" />,
    answer: <FormattedMessageMarkdown id="faq.answer_1" />,
  },
  {
    question: <FormattedMessage id="faq.question_2" />,
    answer: <FormattedMessageMarkdown id="faq.answer_2" />,
  },
  {
    question: <FormattedMessage id="faq.question_3" />,
    answer: <FormattedMessageMarkdown id="faq.answer_3" />,
  },
  {
    question: <FormattedMessage id="faq.question_4" />,
    answer: <FormattedMessageMarkdown id="faq.answer_4" />,
  },
  {
    question: <FormattedMessage id="faq.question_5" />,
    answer: <FormattedMessageMarkdown id="faq.answer_5" />,
  },
  {
    question: <FormattedMessage id="faq.question_6" />,
    answer: <FormattedMessageMarkdown id="faq.answer_6" />,
  },
  {
    question: <FormattedMessage id="faq.question_7" />,
    answer: <FormattedMessageMarkdown id="faq.answer_7" />,
  },
  {
    question: <FormattedMessage id="faq.question_8" />,
    answer: <FormattedMessageMarkdown id="faq.answer_8" />,
  },
  {
    question: <FormattedMessage id="faq.question_9" />,
    answer: <FormattedMessageMarkdown id="faq.answer_9" />,
  },
];
